import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = (props) => (
  <Skeleton width={props.width} height={props.height} className={props.className}/>
);

export default SkeletonLoader;
